import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { QueryClientProvider } from "@tanstack/react-query";
import { SimpleConnectionProvider } from "@/connection/SimpleConnectionProvider";
import { ConnectionAwareProvider } from "@/components/ConnectionAwareProvider";
import { queryClient } from "@/config/queryClient";
import { preloadCriticalComponents } from '@/utils/islandHydration';
import App from './App.tsx'
import './index.css'
import './styles/mobile-optimizations.css'
import './styles/mobile-safe-areas.css'


console.log("🚀 YieldSocial starting up with grants feature...");

// Preload critical components during idle time
preloadCriticalComponents();


const root = createRoot(document.getElementById("root")!);
root.render(
  <StrictMode>
    <SimpleConnectionProvider>
      <ConnectionAwareProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ConnectionAwareProvider>
    </SimpleConnectionProvider>
  </StrictMode>
);

// Hide loading spinner once React has rendered
setTimeout(() => {
  const loader = document.getElementById('app-loader');
  if (loader) {
    loader.style.opacity = '0';
    loader.style.transition = 'opacity 0.3s ease';
    setTimeout(() => loader.remove(), 300);
  }
}, 100);
